<template>
    <div class="ah-uploader">
        <div v-if="ui" class="ui-block">
            <div v-if="fileExt == 'jpg' || fileExt == 'jpeg' || fileExt == 'png'" class="image-block">
                <el-image v-if="filE_ATT" :src="filE_ATT" :previewSrcList="[filE_ATT]"></el-image>
                <div class="upload-btn">
                    <el-button @click="onUploadFile" class="mobile-md-btn"> 更換檔案 </el-button>
                </div>
            </div>
            <div class="file-block" v-else-if="fileExt == 'pdf'">
                <div class="file">
                    <ahFileIcon :ext="fileExt" :url="filE_ATT" />
                </div>
                <div class="upload-btn">
                    <el-button @click="onUploadFile" class="mobile-md-btn"> 更換檔案 </el-button>
                </div>
            </div>
            <div v-else class="">
                <div class="file">
                    <ahFileIcon style="margin-top: 150px" />
                </div>
                <div class="upload-btn">
                    <el-button @click="onUploadFile" class="mobile-md-btn" type="primary"> 上傳檔案 (圖片、PDF檔) </el-button>
                </div>
            </div>
        </div>
        <div v-if="headShot">
            <div v-if="value && !disabled" class="image-block" style="text-align: center; margin-top: 5px;">
                <el-button v-if="isShowDeleteButton" size="mini" @click="onRemoveFile" icon="el-icon-delete"></el-button>
                <el-button size="mini" @click="onUploadFile"> 更換檔案 </el-button>
            </div>
            <div v-else-if='!disabled' class="">
                <div class="upload-btn">
                    <div class="head-shot-block" @click="onUploadFile">
                        <i class="el-icon-plus" />
                    </div>
                </div>
            </div>
        </div>
        <input v-show="false" ref="fileInput" type="file" :accept="accept" @change="onFileInputChange" />
        <!-- 圖片上傳 -->
        <ahImageUploader
            :visible="imgCropModal.visible"
            :file="imgCropModal.file"
            :no-upload="noUpload"
            :rotate-btn="rotateBtn"
            :quality="quality"
            :file-info="fileInfo"
            :watermark="watermark"
            @change="onChange"
            @close="onImageUploaderClose"
            @reupload="openFileSelector"
        />
        <!-- PDF 上傳 -->
        <ahPdfUploader :visible="pdfUploadModal.visible" :file="pdfUploadModal.file" :no-upload="noUpload" :quality="quality" :file-info="fileInfo" @change="onChange" @close="onPdfUploaderClose" />
        <ahDocUploader :visible="docUploadModal.visible" :file="docUploadModal.file" :no-upload="noUpload" :quality="quality" :file-info="fileInfo" @change="onChange" @close="onDocUploaderClose" />
    </div>
</template>

<script>
import ahImageUploader from '@/components/ui/Uploader/ahImageUploader.vue';
import ahPdfUploader from '@/components/ui/Uploader/ahPdfUploader.vue';
import ahDocUploader from '@/components/ui/Uploader/ahDocUploader.vue';
import ahFileIcon from '@/components/ui/ahFileIcon.vue';
import { checkFileSize } from '@/utils/fileValidator';

export default {
    props: {
        ui: Boolean,
        disabled: Boolean,
        headShot: Boolean,
        noUpload: Boolean,
        rotateBtn: Boolean,
        fileInfo: Boolean,
        isShowDeleteButton: Boolean,
        accept: {
            type: String,
            default: 'image/png, image/jpeg, .pdf',
        },
        quality: {
            type: Number,
            default: 0.7,
        },
        value: String,
        watermark: {
            type: String,
            default: '',
        },
    },
    components: {
        ahImageUploader,
        ahPdfUploader,
        ahDocUploader,
        ahFileIcon,
    },
    data() {
        return {
            filE_ATT: null,
            fileExt: null,
            imgCropModal: {
                visible: false,
                file: null,
            },
            pdfUploadModal: {
                visible: false,
                file: null,
            },
            docUploadModal: {
                visible: false,
                file: null,
            },
        };
    },
    methods: {
        onUploadFile() {
            this.openFileSelector();
        },
        openFileSelector() {
            this.$refs.fileInput.click();
        },

        onFileInputChange(event) {
            if (!event.target.files[0]) return;

            // 檢查檔案是否過大
            const fileSizeErrMsg = checkFileSize(event.target.files[0].size);
            if (fileSizeErrMsg) {
                this.$message({
                    showClose: true,
                    message: fileSizeErrMsg,
                    type: 'error',
                });
                return;
            }

            const fileExt = event.target.files[0].name.split('.').pop().toLowerCase();
            console.log('fileExt', fileExt);
            if (fileExt === 'jpeg' || fileExt === 'jpg' || fileExt === 'png') {
                this.onNewImgFile(event.target.files[0]);
            } else if (fileExt === 'pdf') {
                this.onNewPdfFile(event.target.files[0]);
            } else if (fileExt === 'txt' || fileExt === 'xls' || fileExt === 'xlsx') {
                this.onNewDoc(event.target.files[0]);
            } else {
                this.$message({
                    showClose: true,
                    message: '找不到對應上傳器',
                    type: 'error',
                });
            }
        },
        onNewImgFile(imgFile) {
            this.imgCropModal.visible = true;
            this.imgCropModal.file = imgFile;
        },

        onNewPdfFile(pdfFile) {
            this.pdfUploadModal.visible = true;
            this.pdfUploadModal.file = pdfFile;
        },
        onNewDoc(doc) {
            console.log('doccc', doc);
            this.docUploadModal.visible = true;
            this.docUploadModal.file = doc;
        },
        onPdfUploaderClose() {
            this.pdfUploadModal.visible = false;
            this.pdfUploadModal.file = null;
            this.$refs.fileInput.value = null;
        },

        onDocUploaderClose() {
            this.docUploadModal.visible = false;
            this.docUploadModal.file = null;
            this.$refs.fileInput.value = null;
        },

        onImageUploaderClose() {
            this.imgCropModal.visible = false;
            this.imgCropModal.file = null;
            this.$refs.fileInput.value = null;
        },
        onChange(data) {
            // eslint-disable-next-line prefer-destructuring
            this.filE_ATT = this.noUpload ? data.filE_ATT.split('.')[0] : data.filE_ATT;
            this.fileExt = data.filE_ATT.split('.').pop().toLowerCase();
            this.$emit('change', data);
        },
        onRemoveFile() {
            this.$emit('change', null);
        },
    },
};
</script>

<style lang="scss">
.ah-uploader {
    .ui-block {
        display: flex;
        justify-content: center;
        .upload-btn {
            margin-top: 20px;
        }
        .image-block {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 25px 25px 0px 25px;

            .el-image {
                width: 100%;
                img {
                    object-fit: contain;
                    max-height: 350px;
                }
            }
        }
    }

    .head-shot-block {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 100px;
        border: 1px solid #ddd;
        border-radius: 5px;
        cursor: pointer;

        &:hover {
            border: 1px solid #bbb;
            .el-icon-plus {
                color: #bbb;
            }
        }

        .el-icon-plus {
            font-size: 30px;
            color: #ddd;
        }
    }

    .mobile-md-btn {
        width: 250px;
        height: 50px;
    }
}
</style>
